import React, { useEffect, useState } from 'react';
import './TechStack.css';
import { fetchTechStack, Tech } from '../../../api/techApi';

const TechStack: React.FC = () => {
    const [techStack, setTechStack] = useState<Tech[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const getTech = async () => {
            setIsLoading(true);
            const data = await fetchTechStack();
            setTechStack(data);
            setIsLoading(false);
        };
        getTech();
    }, []);

    return (
        <div className="tech-stack">
            <h3>Our Technology Stack</h3>
            <div className="tech-grid">
                {isLoading ? (
                    <div className="loading-small">Loading stack...</div>
                ) : (
                    techStack.map((tech) => (
                        <span key={tech.id} className="tech-badge">
                            {tech.name}
                        </span>
                    ))
                )}
            </div>
        </div>
    );
};

export default TechStack;
